import { type ObjectValuesUnionType } from '../../../../utils/typing';

export const ClientUpdaterActionTypes = Object.freeze({
  DISMISS_UPDATE: `CLIENT_UPDATER:DISMISS_UPDATE`,
  UPDATE: `CLIENT_UPDATER:DISMISS_UPDATE`,
});
export type ClientUpdaterActionType = ObjectValuesUnionType<typeof ClientUpdaterActionTypes>;
